import { BaseService } from './base-service';
export class OwnershipService {
    static fetchOwnerships() {
        return BaseService.get(`ownerships`);
    }
    static saveOwnership(dto) {
        return BaseService.save(`ownership`, dto);
    }
    // ----------------------------------------------------------------------
    // Search Dropdown
    // ----------------------------------------------------------------------
    static searchOwnershipCombo(selfId, search) {
        let qs = encodeURIComponent(search);
        return BaseService.get(`ownerships-combo/${selfId}?search=${qs}`);
    }
}
